import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const activityTemplateService = {
  getTemplate: async (user, templateId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/activity/${templateId}`,
      getAxiosOptions(user)
    )
  },
  getAllToRoutes: (user, activityTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/route/activity/to/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getProcessAllRoutes: (user, processTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/route/process/${processTemplateId}`,
      getAxiosOptions(user)
    )
  },
  saveActivityTemplate: async (user, data) => {
    return (await axios.put(`${NODE_BASE_URL}/template/activity`, data, getAxiosOptions(user))).data
  },
  getAllActivitiesOfCompany: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/template/activity/get-all-activities/${companyId}`,
        getAxiosOptions(user)
      )
    ).data
  },
}
